import { useForm } from 'react-hook-form';

import { EditForm } from 'sections/EditForm';
import { SectionType } from 'sections/TabWrap';

import { formData } from './form.data';

const useTechnicalFeatures = () => {
  const { register } = useForm();

  const sections: SectionType[] = [
    {
      id: 1,
      content: <EditForm onSubmit={() => null} data={formData} register={register} />,
    },
  ];

  return {
    sections,
  };
};

export { useTechnicalFeatures };
